import React, { useEffect, useState } from 'react'
import styles from '../styles/Register.module.scss'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import {
	Modal,
	Button,
	Form,
	Row,
	Col,
	ListGroup
} from 'react-bootstrap'

export default function EducationModal ({ show, setShow, educations, setEducations, educationEnums }): JSX.Element {
	const { t } = useTranslation()
	const initialInputs = {
		id: 0,
		schoolName: '',
		educationLevel: '',
		educationDisplay: '',
		fieldOfStudy: '',
		startYear: '',
		endYear: '',
		grade: 0,
		description: ''
	}

	const [inputs, setInputs] = useState<{ grade: any, id: any, schoolName: string, educationLevel: string, educationDisplay: string, fieldOfStudy: string, startYear: string, endYear: string, description: string }>(initialInputs)
	const { educationDisplay } = inputs

	// Store matching options(Degree field)
	const [filteredArr, setFilteredArr] = useState<Array<{ display: string, educationLevel: string }>>([])
	const [yearArrs, setYearArrs] = useState<{ startArr: number[], endArr: number[] }>({
		startArr: [],
		endArr: []
	})
	const { startArr, endArr } = yearArrs

	const addEducation = async (event): Promise<void> => {
		event.preventDefault()
		event.stopPropagation()

		inputs.id = uuidv4()
		// inputs.description = inputs.description.trim()
		const newArr = educations.concat(inputs)
		setEducations(newArr)
		setShow(false)
		setInputs(initialInputs)
	}

	useEffect(() => {
		const isMatch = educationEnums.some(ele => ele.display.toLowerCase() === educationDisplay.toLowerCase())
		if (educationDisplay.length === 0 || isMatch) {
			setFilteredArr([])
		} else if (educationDisplay.length > 0) {
			const filtered = educationEnums.filter(ele => {
				const lowerCaseEnum = ele.display.toLowerCase()
				const degreeInput = educationDisplay.toLowerCase()
				return lowerCaseEnum.indexOf(degreeInput) >= 0
			})
			setFilteredArr(filtered)
		}

		if (startArr.length === 0 || endArr.length === 0) {
			const currentYear = moment().year()
			for (let i = currentYear; i >= 1920; i--) startArr.push(i)
			for (let i = currentYear + 7; i >= 1920; i--) endArr.push(i)
			setYearArrs({
				startArr, endArr
			})
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [educationDisplay])

	const validate = (event): void => {
		const name = event.target.name
		const str = event.target.value
		const temp = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		setInputs({ ...inputs, [name]: temp })
	}
	return (
		<Modal show={show} onHide={() => setShow(false)} size='lg'>
			<Form onSubmit={addEducation}>
				<Modal.Header closeButton className='text-center'>
					<h3 style={{ width: '100%' }}>{t('education.add_education')}</h3>
				</Modal.Header>
				<Modal.Body style={{ padding: '2rem' }}>
					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('education.school')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='schoolName'
									type='text'
									placeholder='Singapore Polytechnic'
									value={inputs.schoolName}
									onChange={event => validate(event)}
									required
								/>
							</Form.Group>
						</Col>
					</Row>

					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('education.edu_level')}
									<span className={styles.mandatory}>*</span>
                  &nbsp;
									<span style={{ fontWeight: 'lighter', fontSize: '.7em' }}>{t('education.select_from_dropdown')}</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									type='text'
									placeholder='Degree / Certificate'
									value={educationDisplay}
									onChange={event => {
										const inputValue = (event.target.value).replace(/[`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\]/gi, '') // keep - /
										const isMatch = educationEnums.some(ele => ele.display.toLowerCase() === inputValue.toLowerCase())
										if (!isMatch) {
											setInputs({
												...inputs,
												educationDisplay: inputValue,
												educationLevel: inputValue
											})
										} else if (isMatch) {
											const findEnum = () => {
												const foundObj = educationEnums.find(ele => ele.display.toLowerCase() === inputValue.toLowerCase())
												return foundObj.educationLevel
											}
											setInputs({
												...inputs,
												educationDisplay: inputValue,
												educationLevel: findEnum()
											})
										}
									}}
									required
								/>
							</Form.Group>
						</Col>
					</Row>

					{filteredArr.length > 0 && (
						<ListGroup style={{
							position: 'absolute',
							width: '92%',
							top: '204px',
							zIndex: 1
						}}
						>
							{filteredArr.map((ele, index) => {
								const updateTextInput = () => {
									setInputs({
										...inputs,
										educationDisplay: ele.display,
										educationLevel: ele.educationLevel
									})
								}
								return (
									<ListGroup.Item
										key={index}
										onClick={updateTextInput}
										action
									>
										{ele.display}
									</ListGroup.Item>
								)
							})}
						</ListGroup>)}

					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('education.field_of_study')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='fieldOfStudy'
									type='text'
									placeholder='Business'
									value={inputs.fieldOfStudy}
									onChange={event => validate(event)}
									required
								/>
							</Form.Group>
						</Col>
					</Row>

					<Row className='mb-3'>
						<Col sm={12} md={6}>
							<Form.Group className='mb-3'>
								<Form.Label>
									{t('education.start_year')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									as='select'
									value={inputs.startYear}
									onChange={event => {
										setInputs({
											...inputs,
											startYear: event.target.value
										})
									}}
									required
								>
									<option value='' disabled>{t('education.select_year')}</option>
									{/* <option key={1} value={2021}>2021</option>
                    <option key={2} value={2020}>2020</option> */}
									{startArr.map((year, index) => (
										<option key={index} value={year}>
											{year}
										</option>
									))}
								</Form.Control>
							</Form.Group>
						</Col>
						<Col sm={12} md={6}>
							<Form.Group>
								<Form.Label>
									{t('education.end_year')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									as='select'
									value={inputs.endYear}
									onChange={event => {
										setInputs({
											...inputs,
											endYear: event.target.value
										})
									}}
									required
								>
									<option value='' disabled>{t('education.select_year')}</option>
									{endArr.map((year, index) => (
										<option key={index} value={year}>
											{year}
										</option>
									))}
								</Form.Control>
							</Form.Group>
						</Col>
					</Row>

					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>{t('education.grade')}</Form.Label>
								<Form.Control
									className={styles.formControl}
									type='number'
									placeholder='2.5'
									value={inputs.grade !== 0 ? inputs.grade : null}
									onChange={event => {
										const value = event.target.value
										setInputs({
											...inputs,
											// grade: parseFloat(event.target.value)
											grade: value !== '' ? parseFloat(value) : null
										})
									}}
								/>
							</Form.Group>
						</Col>
					</Row>

					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('education.description')}
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='description'
									as='textarea'
									rows={3}
									value={inputs.description}
									onChange={event => validate(event)}
								/>
							</Form.Group>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant='primary'
						type='submit'
						className='text-white'
					>
						{t('education.save')}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}
